export default {
  backoffice: 'BACKOFFICE',
  portal: 'PORTAL'
}
